import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";
import _ from 'lodash'

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const TestGaussianChart = ({ gaussian_chart, test_color, candidate_name = 'Inconnu', candidate_score }) => {
  const { ranges, data_values } = gaussian_chart;

  const totalPeople = data_values.reduce((acc, val) => acc + parseInt(val), 0);
  const scoreRangeIndex = ranges.findIndex(range =>
    candidate_score >= parseInt(range.min) && candidate_score <= parseInt(range.max)
  );

  let peopleBelowScore = 0;
  for (let i = 0; i < scoreRangeIndex; i++) {
    peopleBelowScore += parseInt(data_values[i]);
  }

  peopleBelowScore += parseInt(data_values[scoreRangeIndex]) / 2;

  const percentile = Math.round((peopleBelowScore / totalPeople) * 100);

  const backgroundColor = data_values.map((_, index) =>
    index === scoreRangeIndex
      ? (test_color ? test_color + '' : "rgba(54, 162, 235, 1)")
      : "linear-gradient(90deg, #E5E5E5 0%, rgba(134, 134, 134, 0.35) 100%)"
  );

  const borderColor = data_values.map((_, index) =>
    index === scoreRangeIndex
      ? (test_color ? test_color : "rgba(54, 162, 235, 0.5)")
      : "rgba(200, 200, 200, 0.5)"
  );

  const data = {
    labels: ranges.map((range) => `${range.min}-${range.max}`),
    datasets: [
      {
        label: "Values",
        data: data_values,
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderWidth: 1,
        borderSkipped: false,
        borderRadius: 10,
      },
    ],
  };

  const roundToNextWellRoundedZero = (num) => {
    const magnitude = Math.pow(10, Math.floor(Math.log10(num)));
    return Math.ceil(num / magnitude) * magnitude;
  };

  const options = {
    responsive: true,
    layout: {
      padding: {
        bottom: 10  // Doesn't work ?
      },
      margin: {
        bottom: 10
      }
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
      annotation: {
        annotations: {
          line1: {
            type: 'line',
            yMin: 0,
            yMax: roundToNextWellRoundedZero(Math.max(...data_values)),
            xMin: candidate_score,
            xMax: candidate_score,
            borderColor: 'red',
            borderWidth: 2,
            label: {
              enabled: true,
              content: `${candidate_name}'s Score`,
              position: 'top'
            }
          }
        }
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
        display: false,
        offset: true
      },
      y: {
        beginAtZero: true,
        max: roundToNextWellRoundedZero(Math.max(...data_values)),
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
        display: false,
        offset: true
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <div style={{ height: 300, width: 450, margin: '0 auto' }}>
      <Bar data={data} options={options} />
      <h2 className="is-size-5 has-text-centered has-text-weight-light">
        <span className="has-text-dgrad-deepsy-blue">{_.capitalize(candidate_name)}</span> se situe dans le top {100 - percentile}% des participants
      </h2>
    </div>
  );
};

export default TestGaussianChart;